/* 客源设置 */
<template>
  <div>
    <div class="warpper_top">
      <h1 class="warpper_top_title">客源设置</h1>
      <!-- <a-button  type="primary"  @click="submitForm">
                保存
            </a-button> -->
    </div>
    <div class="warpper_con">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules" layout="horizontal">
        <!-- v-bind="layout" -->
        <a-form-model-item class="mr50" colon label="客源类型" prop="rentSaleTypeOptions">
          <a-select
            v-model="dataInfo.rentSaleType"
            class="w200"
            size="default"
            placeholder="请选择"
            @change="typeChangeFn"
          >
            <a-select-option v-for="t in rentSaleTypeOptions" :key="t.dictValue" :value="t.dictValue">{{
              t.dictLabel
            }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <h3 class="page_item_title">掉客设置</h3>
        <div class="disFlex line">
          <a-form-model-item class="mr50" colon label="掉小公共" prop="loseSmallPool">
            <a-input :max-length="6" size="default" v-model="dataInfo.loseSmallPool" suffix="天"> </a-input>
          </a-form-model-item>
          <a-form-model-item class="mr50" colon label="掉大公共" prop="loseBigPool">
            <a-input :max-length="6" size="default" v-model="dataInfo.loseBigPool" suffix="天"></a-input>
          </a-form-model-item>
          <a-form-model-item class="mr50" colon label="掉盘提醒天数" prop="fallNotify">
            <a-input :max-length="6" size="default" v-model="dataInfo.fallNotify" suffix="天"> </a-input>
          </a-form-model-item>
        </div>

        <h3 class="page_item_title">公转私</h3>
        <div class="disFlex line">
          <a-form-model-item class="mr50" colon label="最大认领次数" prop="receiveMaxNum">
            <a-input :max-length="6" size="default" v-model="dataInfo.receiveMaxNum" suffix="天"></a-input>
          </a-form-model-item>
          <a-form-model-item class="mr50" colon label="认领锁定时长" prop="receiveLockTime">
            <a-input :max-length="6" size="default" v-model="dataInfo.receiveLockTime" suffix="天"></a-input>
          </a-form-model-item>

          <a-form-model-item class="mr50" colon label="认领释放时长" prop="receiveReleaseTime">
            <a-input :max-length="6" size="default" v-model="dataInfo.receiveReleaseTime" suffix="小时"></a-input>
          </a-form-model-item>

          <a-form-model-item class="mr50" colon label="是否开启认领审批" prop="isOpenReceiveAudit">
            <a-select v-model="dataInfo.isOpenReceiveAudit" size="default" placeholder="请选择">
              <a-select-option v-for="s in openStatusOptions" :key="s.dictValue" :value="s.dictValue">{{
                s.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>

        <h3 class="page_item_title" style="margin-bottom: 20px">人员类别</h3>
        <div class="line" style="margin-bottom: 20px; padding-bottom: 20px">
          <a-checkbox v-if="dataInfo.isAccendantPerson === 'Y'" checked @click="handleCheck('isAccendantPerson')">
            维护人
          </a-checkbox>
          <a-checkbox v-else @click="handleCheck('isAccendantPerson')"> 维护人 </a-checkbox>

          <a-checkbox v-if="dataInfo.isInputPerson === 'Y'" checked @click="handleCheck('isInputPerson')">
            录入人
          </a-checkbox>
          <a-checkbox v-else @click="handleCheck('isInputPerson')"> 录入人 </a-checkbox>
        </div>

        <div class="disFlex btn_center">
          <a-button type="primary" @click="submitForm"> 保存 </a-button>
        </div>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import {
  touristResourceList,
  getTouristResource,
  addTouristResource,
  updateTouristResource,
  delTouristResource
} from '@/api/setting/touristresource'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Touristresource',
  components: {},
  mixins: [tableMixin],
  data () {
    return {
      curType: '',
      openStatusOptions: [],
      rentSaleTypeOptions: [],
      total: 0,
      list: [],
      dataObj: {},
      loading: false,
      submitLoading: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      },

      queryParam: {
        pageNum: 1,
        pageSize: 10,
        rentSaleType: '1' // 1租2售
      },
      dataInfo: {
        isAccendantPerson: 'N', //	维护人
        isInputPerson: 'N', //	录入人
        fallNotify: undefined, //	掉盘提醒天数（天）
        id: undefined, // 新增时不传，修改时必传
        loseBigPool: undefined, //	掉大公共（天）
        loseSmallPool: undefined, //	掉小公共（天）
        receiveLockTime: undefined, //	认领锁定时长（天）
        receiveMaxNum: undefined, //	最大认领次数（次/天）

        receiveReleaseTime: undefined, //	认领释放时长（小时）		true
        isOpenReceiveAudit: undefined, //	是否开启认领审批		true
        rentSaleType: undefined //	租售类型 字典表类型：rent_sale_type
      },
      rules: {
        rentSaleType: [{ required: true, message: '必选', trigger: 'blur' }],
        fallNotify: [{ required: true, pattern: /^[0-9]+$/, message: '格式错误', trigger: 'blur' }],
        loseBigPool: [
           { required: true, message: '必填', trigger: ['change', 'blur'] },
           { pattern: /^[0-9]+$/, message: '格式错误', trigger: ['change', 'blur'] },
          //  { validator: this.loseDayValidator, trigger: ['change', 'blur'] }
        ],
        loseSmallPool: [
          { required: true, message: '必填', trigger: ['change', 'blur'] },
           { pattern: /^[0-9]+$/, message: '格式错误', trigger: ['change', 'blur'] },
          //  { validator: this.loseDaySmallValidator, trigger: ['change', 'blur'] }
        ],
        receiveLockTime: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '必填',
            trigger: 'blur'
          }
        ],
        receiveMaxNum: [{ required: true, pattern: /^[0-9]+$/, message: '必填', trigger: 'blur' }],
        receiveReleaseTime: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '必填',
            trigger: 'blur'
          }
        ],
        isOpenReceiveAudit: [{ required: true, message: '必选', trigger: 'blur' }]
      },
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      },
      columns: []
    }
  },
  filters: {},
  created () {
    // 是否开启open_status sys_yes_no
    this.getDicts('sys_yes_no').then((response) => {
      this.openStatusOptions = response.data
    })
    // 租售类型 字典表类型：rent_sale_type
    this.getDicts('rent_sale_type').then((response) => {
      this.rentSaleTypeOptions = response.data
      // console.log(this.rentSaleTypeOptions)
    })
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    // 客源类型改变重新请求列表
    typeChangeFn (e) {
      this.curType = e
      this.queryParam.rentSaleType = e
      this.getList()
    },
    // 人员类别
    handleCheck (key) {
      this.dataInfo[key] = this.dataInfo[key] === 'Y' ? 'N' : 'Y'
    },
     loseDaySmallValidator (rule, value, callback) {
      const data = this.dataInfo
      const bigN = data.loseBigPool
      const smallN = value
      if (bigN < smallN) {
        callback(new Error('掉小公共天数不能超过掉大公共天数'))
      } else {
        this.$refs.dataInfo.validateField('loseBigPool')
        callback()
      }
    },
    loseDayValidator (rule, value, callback) {
      const data = this.dataInfo
      const bigN = value
      const smallN = data.loseSmallPool
      if (bigN < smallN) {
        callback(new Error('掉小公共天数不能超过掉大公共天数'))
      } else {
         this.$refs.dataInfo.validateField('loseSmallPool')
        callback()
      }
    },
    /** 查询客源信息列表 */
    getList () {
      this.loading = true
      touristResourceList(this.queryParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.total = resData.length
          if (this.total > 0) {
            // this.list = resData.records;
            // this.dataObj = resData.records[0];
            // this.dataInfo = this.dataObj;

            this.list = resData
            this.dataObj = resData[0]
            this.dataInfo = this.dataObj
            this.curType = this.dataInfo.rentSaleType
          } else {
            this.dataInfo = {}
            this.dataInfo.rentSaleType = this.curType
          }
        }
        this.loading = false
      })
    },
    handleProvinceChange (value) {
      this.cities = cityData[value]
      this.secondCity = cityData[value][0]
    },
    submitForm () {
      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          if (this.dataInfo.id !== undefined) {
            updateTouristResource(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addTouristResource(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    getDetail () {
      const touristResourceId = this.dataInfo.id
      getTouristResource(touristResourceId).then((response) => {
        this.dataInfo = response.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
.w200 {
  width: 200px;
}
.warpper_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.btn_center {
  height: 100px;
  justify-content: center;
  align-items: center;
}

.warpper_top_title {
  font-size: @titleFontSize;
  font-weight: bold;
  color: @titleColor;
}
.warpper_top,
.warpper_con {
  background: #fff;
  padding: 20px;
}
.warpper_con {
  margin-top: 10px;
}
.page_item_title {
  font-size: 16px;
  color: @titleColor;
  font-weight: bold;
}

.line {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
</style>
